import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';


const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Original Value',
    dataIndex: 'original_value',
    key: 'original_value',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Start Depreciation Date',
    dataIndex: 'start_depreciating_date',
    key: 'start_depreciating_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{`${new Date(record.start_depreciating_date).toLocaleDateString()}`}</span>
  },
  {
    title: 'Duration',
    dataIndex: 'duration',
    key: 'duration',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{`${record.duration.number} ${record.duration.period}`}</span>
  },
  {
    title: 'Depreciable Value',
    dataIndex: 'depreciable_value',
    key: 'depreciable_value',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{`${record.expense_board[0].expense}`}</span>
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'running' ? "text-blue-600 bg-blue-100 w-max" : record.status === 'done' ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.status}</Badge>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/deferred-expenses/'+record.seo}>
        EDIT
      </Link>
    )
  }
]

const DeferredExpense = () => {
  const deferredExpenses = useLoaderData();
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Deferred Expense</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/deferred-expenses/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        dataSource={deferredExpenses}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default DeferredExpense;